import { CONTENT_TOO_LARGE_ERROR } from '../../constants';

// Matches on name, not instanceof: tsconfig targets es5, where a downlevelled
// `class extends Error` loses its prototype and breaks instanceof.
export const isContentTooLargeError = (error: unknown): boolean =>
  error instanceof Error && error.name === CONTENT_TOO_LARGE_ERROR;
